import React from 'react';

import { Icon } from '@chakra-ui/react';

export const RuntimeInsightsIcon = props => (
  <Icon
    viewBox="0 0 508.027 508.027"
    color="inherit"
    h="full"
    w="full"
    {...props}
  >
    <g>
      <g>
        <path
          d="M74.513,138.813l-41.4-22.6c-6.8-3.7-15.4-1.2-19.1,5.6c-3.7,6.8-1.2,15.4,5.7,19.1l41.3,22.6c6.8,3.7,15.4,1.2,19.1-5.6
			C83.813,151.113,81.313,142.513,74.513,138.813z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M161.613,73.513l-23.2-38.2c-4-6.7-12.7-8.8-19.4-4.7c-6.7,4-8.8,12.7-4.7,19.4l23.2,38.2c4,6.7,12.7,8.8,19.4,4.7
			C163.613,88.813,165.713,80.213,161.613,73.513z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M254.013,0.013c-7.8,0-14.1,6.3-14.1,14.1v43.4c0,7.8,6.3,14.1,14.1,14.1c7.8,0,14.1-6.3,14.1-14.1v-43.4
			C268.113,6.313,261.813,0.013,254.013,0.013z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M389.013,30.613c-6.7-4-15.3-1.9-19.4,4.7l-23.2,38.2c-4,6.7-1.9,15.4,4.7,19.4c6.7,4.1,15.3,1.9,19.4-4.7l23.2-38.2
			C397.713,43.313,395.613,34.713,389.013,30.613z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M493.913,121.813c-3.7-6.8-12.3-9.4-19.1-5.6l-41.4,22.6c-6.8,3.7-9.3,12.2-5.6,19.1c3.7,6.8,12.3,9.4,19.1,5.6l41.4-22.6
			C495.113,137.213,497.713,128.613,493.913,121.813z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M507.013,488.713l-25.1-63.4c-2.1-5.4-7.3-8.9-13.1-8.9h-29.4l-30.2-220.5c-5.2-40-39.4-70.1-79.8-70.1h-150.9
			c-40.3,0-74.6,30.1-79.7,70l-30.2,220.5h-29.4c-5.8,0-11,3.5-13.1,8.9l-25.1,63.5c-3.7,9.3,3.2,19.3,13.1,19.3h479.8
			C503.813,508.013,510.713,498.013,507.013,488.713z M126.813,199.513c3.3-26,25.6-45.5,51.8-45.5h150.9
			c26.2,0,48.4,19.6,51.8,45.6l29.7,216.7h-313.9L126.813,199.513z M34.913,479.813l13.9-35.2h410.4l13.9,35.2H34.913z"
        />
      </g>
    </g>
    <g>
      <g>
        <polygon points="232.913,205.313 232.913,234.913 239.813,320.913 268.013,320.913 275.113,234.913 275.113,205.313 		" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="254.013" cy="358.013" r="21" />
      </g>
    </g>
  </Icon>
);
